export const SORT_DIR = {
  ASC: "ASC",
  DESC: "DESC",
}

export const DAY_FORMAT = "YYYY-MM-DD"
